import tmpl from './password.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',
	},


	onSubmit: function( evt )
	{
		evt.preventDefault();

		var data = this.$('form').serializeJSON();
		this.$(':input, button').prop('disabled',true);

		this.model.set( data );

		// Validation locale
		if( !this.model.isValid() )
		{
			return this.render();
		}

		// Sauvegarde en local
		this.model.set('todo','update');
		app.commit();

		app.redirect('user/account');
	},


	render: function()
	{
		this.doRender({
			user: this.model
		});
	}

});

